import React from "react";
import "./App.css";
import SignInPage from "./pages/SignIn";

function App() {
  return (
    <div className="App">
      <SignInPage />
    </div>
  );
}

export default App;
